import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import FormControl from '@material-ui/core/FormControl';
import RadioGroup from '@material-ui/core/RadioGroup';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { navigate, useLocation } from '@reach/router';
import { useTranslation } from 'react-i18next';
import { find, get } from 'lodash';
import { Layout } from '~/Layout';
import getCrumbs from '~/Layout/crumbs';
import ImageRadio from './ImageRadio';
import Modal from '~/common/Modal';

const useStyles = makeStyles(() => ({
  container: {
    height: '100%',
    overflow: 'auto',
    paddingLeft: 30,
    paddingRight: 30,
    paddingTop: 20,
  },
  title: {
    textTransform: 'uppercase',
    marginTop: 20,
    marginBottom: 30,
  },
  fieldset: {
    marginTop: 50,
    width: '100%',
  },
  item: {
    marginBottom: 44,
  },
  tileWrap: {
    position: 'relative',
    display: 'inline-block',
  },
  dimOverlay: {
    position: 'absolute',
    top: 0, right: 0, bottom: 0, left: 0,
    background: 'transparent',
    pointerEvents: 'none',
    borderRadius: 'inherit',
  },
  dimmed: {
    opacity: 0.35,
    transition: 'opacity 150ms ease',
  },
}));

const Container = ({
  container, selectContainer, resetQuantity, profile: { containers }, submitDelay,
}) => {
  const classes = useStyles();
  const { t } = useTranslation('container_page');
  const location = useLocation();
  const [infoOpen, setInfoOpen] = React.useState(false);
  const [dimOthers, setDimOthers] = React.useState(false); 

  const selectedId = (container && typeof container === 'object')
  ? get(container, 'id', null)
  : container;

    React.useEffect(() => {
        if (location && location.state && location.state.showInfoModal) {
          setInfoOpen(true);        
          setDimOthers(false);      
        } else {
          setDimOthers(false);     
        }
      }, [location]);

    const handleInfoClose = () => {
        setInfoOpen(false);
        setDimOthers(true);       
      };

  const handleChange = (event) => {
    const containerId = event.target.value * 1;
    const prevId = selectedId;
    
      if (prevId === containerId) {
        setTimeout(function () {
          navigate(containerId < 0 ? '/exactQuantity' : '/quantity');
        }, submitDelay);
        return;
      }
        
      if (containerId < 0) {
        selectContainer({ container: { id: -1, name: 'EXACT_QUANTITY', volume: -1, unit: '' } });
        setTimeout(function () { navigate('/exactQuantity'); }, submitDelay);
      } else {
        var selectedContainer = find(containers, { id: containerId });
        selectContainer({ container: selectedContainer });
        setTimeout(function () { navigate('/quantity'); }, submitDelay);
      }
  };
  
  

  const baseImage = aContainer => (
    `${aContainer.image_base_url}/${find(aContainer.images, { percentage: 0 }).url}`
  );

    const isDimmed = function(id){
        if (!dimOthers) return false;     
        if (selectedId == null) return false;
        return selectedId !== id;        
      };

  const radio = aContainer => (
    <ImageRadio
      title={aContainer.name}
      onClick={handleChange}
      value={aContainer.id}
      name="container"
      checked={selectedId === aContainer.id}
      inputProps={{ 'aria-label': aContainer.name }}
      image={baseImage(aContainer)}
    />
  );

  const renderTile = (aContainer) => {
    const dim = isDimmed(aContainer.id);
    return (
      <div className={classes.tileWrap}>
        <div className={dim ? classes.dimmed : ''}>
          <ImageRadio
            title={aContainer.name}
            onClick={handleChange}
            value={aContainer.id}
            name="container"
            checked={selectedId === aContainer.id}
            inputProps={{ 'aria-label': aContainer.name }}
            image={baseImage(aContainer)}
          />
        </div>
        {dim ? <div className={classes.dimOverlay} /> : null}
      </div>
    );
  };

  const renderExactTile = () => {
    const dim = isDimmed(-1);
    return (
      <div className={classes.tileWrap}>
        <div className={dim ? classes.dimmed : ''}>
          <ImageRadio
            title={t('buttons.EXACT_QUANTITY.title')}
            onClick={handleChange}
            value={-1}
            name="container"
            checked={selectedId === -1}
            inputProps={{ 'aria-label': t('buttons.EXACT_QUANTITY.title') }}
            image="/img/calculator.png"
          />
        </div>
        {dim ? <div className={classes.dimOverlay} /> : null}
      </div>
    );
  };

  const sm = (12 / Math.ceil((containers.length + 1) / 2));

  return (
    <Layout crumbs={getCrumbs('home/kindOfWaste/whyTossed/destination/container')} previousScreen="/destination">
      <Box className={classes.container}>
        <Typography variant="h2" align="center">{t('title')}</Typography>
        <FormControl component="fieldset" className={classes.fieldset}>
          <RadioGroup aria-label={t('short_title')} name="destination">
            <Grid container direction="row" align="center" justifyContent="center" spacing={3}>
              {containers
                .map(aContainer => (
                  <Grid item xs={12} sm={sm} key={aContainer.id} className={classes.item}>
                    {renderTile(aContainer)}
                  </Grid>
                ))}
                <Grid item xs={12} sm={sm} className={classes.item}>
                {renderExactTile()}
              </Grid>
            </Grid>
          </RadioGroup>
        </FormControl>
      </Box>

      <Modal
        open={infoOpen}
        onClose={handleInfoClose}
        maxWidth="md"
        paperStyle={{ maxWidth: 800, width: 700, padding: 2, paddingTop:0,marginTop:1}}
        contentStyle={{ padding: 5, textAlign: 'left', display: 'block', marginLeft:15 }}         actionsStyle={{ paddingTop: 8, paddingBottom: 8 }}
        blockOutsideClose   
        actions={[
          {
            label: t('review_modal.ok'),
            onClick: handleInfoClose,
            variant: 'primary',
            type: 'button',
            width: 50,
            style: { padding: '6px 14px', minHeight: 44 },
          },
        ]}
        title={null}
      >
        <Typography variant="body1" paragraph style={{ marginBottom: 18, fontSize: '20px', fontWeight: 500,textAlign: 'left' }}>
          {t('review_modal.intro_review')}
        </Typography>
        <Typography variant="body1" paragraph style={{ fontSize: '20px', fontWeight: 500,textAlign: 'left'}}>
          {t('review_modal.intro_check')}
        </Typography>

        <Typography variant="body1" component="ul" style={{ paddingLeft: 16, margin: 0, fontSize: '20px', fontWeight: 500, textAlign: 'left'}}>
          <Typography component="li" style={{ fontSize: '20px', fontWeight: 500, lineHeight: 1.15 }}>{t('review_modal.items.container_type')}</Typography>
          <Typography component="li" style={{ fontSize: '20px', fontWeight: 500, lineHeight: 1.15 }}>{t('review_modal.items.container_fullness')}</Typography>
          <Typography component="li" style={{ fontSize: '20px', fontWeight: 500, lineHeight: 1.15 }}>{t('review_modal.items.waste_type')}</Typography>
          <Typography component="li" style={{ fontSize: '20px', fontWeight: 500, lineHeight: 1.15 }}>{t('review_modal.items.count')}</Typography>
        </Typography>

        <Typography variant="body1" paragraph style={{ fontSize: '20px', fontWeight: 500,textAlign: 'left' }}>
          {t('review_modal.exact_note')}
        </Typography>
      </Modal>
    </Layout>
  );
};

Container.defaultProps = {
  container: null,
};

Container.propTypes = {
  container: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    volume: PropTypes.number.isRequired,
    unit: PropTypes.string.isRequired
  }),
  selectContainer: PropTypes.func.isRequired,
  resetQuantity: PropTypes.func.isRequired,
  profile: PropTypes.shape({
    containers: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      volume: PropTypes.number.isRequired,
      unit: PropTypes.string.isRequired,
      images: PropTypes.arrayOf(PropTypes.shape({
        percentage: PropTypes.number.isRequired,
        url: PropTypes.string.isRequired,
      })),
    })),
  }).isRequired,
  submitDelay: PropTypes.number.isRequired,
};

export default Container;
